import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import confetti from 'canvas-confetti';
import Banner30Anos from '../../img/celebrations/aniver.png';
import '../../styles/celebrations.css';

const Celebracao: React.FC = () => {
    const location = useLocation();
    const [showBanner, setShowBanner] = useState(false);
    const [fadeOut, setFadeOut] = useState(false);

    useEffect(() => {
        // Só executa na home
        if (location.pathname !== '/') {
            setShowBanner(false); // Esconde se não estiver na home
            setFadeOut(false);
            return;
        }

        // Mostra o banner imediatamente
        setShowBanner(true);
        setFadeOut(false); // Reseta o fadeOut

        // Configura o confetti
        const myConfetti = confetti.create(undefined, { resize: true });

        const canvas = document.querySelector('canvas');
        if (canvas) {
            canvas.style.zIndex = '10000';
            canvas.style.position = 'fixed';
            canvas.style.top = '0';
            canvas.style.left = '0';
        }

        // Dispara confetti a cada 650ms por 5 segundos
        const interval = setInterval(() => {
            myConfetti({
                particleCount: 200,
                spread: 90,
                origin: { x: Math.random(), y: 0.5 },
            });
        }, 650);

        // Para o confetti após 5s
        const stopConfettiTimer = setTimeout(() => {
            clearInterval(interval);
        }, 5000);

        // Inicia o fadeOut após 6s
        const fadeTimer = setTimeout(() => {
            setFadeOut(true);
        }, 6000);

        // Fecha o banner após 8s
        const closeTimer = setTimeout(() => {
            setShowBanner(false);
            if (canvas) canvas.remove();
        }, 8000);

        // Limpeza ao desmontar ou sair da home
        return () => {
            clearInterval(interval);
            clearTimeout(stopConfettiTimer);
            clearTimeout(fadeTimer);
            clearTimeout(closeTimer);
            if (canvas) canvas.remove();
        };
    }, [location.pathname]); // Roda sempre que a rota mudar

    const handleClose = () => {
        setFadeOut(true);
        setTimeout(() => {
            setShowBanner(false);
            const canvas = document.querySelector('canvas');
            if (canvas) canvas.remove();
        }, 1500);
    };

    if (!showBanner) return null;

    return (
        <div className={`celebracao-overlay ${fadeOut ? 'fade-out' : ''}`}>
            <div className="celebracao-card">
                <button className="close-button" onClick={handleClose}>×</button>
                <img src={Banner30Anos} alt="30 anos da Clínica Mediação" />
            </div>
        </div>
    );
};

export default Celebracao;